export * from '@primeuix/themes/nora/speeddial';
export { default } from '@primeuix/themes/nora/speeddial';
